import * as actionTypes from "../constants/ActionTypes/SignIn"

export const BOLAPICall = (BOLLoginToken, loginPageURL = null) => ({
    type: actionTypes.BOL_API_INIT,
    BOLLoginToken,
    loginPageURL
})
